import { Link } from "gatsby"
import styled from "styled-components"

const BreadcrumbLink = styled(Link)`
  color: var(--primaryVariant);
`

export default BreadcrumbLink
